'use client';

import styled from 'styled-components';

const HomeTemplateStyle = styled.section`
	--distanceHero: var(--sp7x);
	--iconSizeHero: var(--sp7x);

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceHero: var(--sp4x);
		--iconSizeHero: var(--sp6x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceHero: var(--sp3x);
		--iconSizeHero: var(--sp5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceHero: var(--sp4x);
		--iconSizeHero: var(--sp4x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceHero: var(--sp3x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceHero: var(--sp2x);
	}
`;

export default HomeTemplateStyle;
